import { useQuery } from '@tanstack/react-query';
import { campaignKeys } from '../queryKeys';
import { getLinkFunnelSummary, type LinkFunnelSummaryDto } from '../api/shareGrants';

/**
 * useLinkFunnelSummary — device split, public/private split, login-wall
 * drop-off, and public-to-login conversions for a campaign's shareable
 * links. Powers the Links tab's summary section, sibling to useShareGrants.
 */
export function useLinkFunnelSummary(campaignId: string, window?: string) {
  return useQuery<LinkFunnelSummaryDto>({
    queryKey: campaignKeys.linkFunnelSummary(campaignId, window),
    queryFn: () => getLinkFunnelSummary(campaignId, window),
    enabled: !!campaignId,
  });
}
